'use strict';

var utils_string_isString = require('./utils/string/isString.js');
var utils_isType_isType = require('./utils/isType/isType.js');

function extractErrorKey(syncValidations, formValidations, fieldValue, formValues) {
  return function (validationKey) {
    var _ref = syncValidations[validationKey] || {},
        params = _ref.params;

    var validationFunction = formValidations[validationKey];

    if (!utils_isType_isType.isType('function', validationFunction)) {
      console.error("You must provide a function to form validation \"".concat(validationKey, "\""));
      return true;
    }

    return !validationFunction(fieldValue, params, formValues);
  };
}

function validateField(formValidations, syncValidations, formValues) {
  return function (fieldValue) {
    var errorKey = Object.keys(syncValidations).find(extractErrorKey(syncValidations, formValidations, fieldValue, formValues));
    var hasError = errorKey;
    var currentValdationErrorValue = syncValidations[errorKey];
    var isErrorFeedbackString = utils_string_isString.isString(currentValdationErrorValue);

    if (!hasError) {
      return undefined;
    }

    if (isErrorFeedbackString) {
      return currentValdationErrorValue;
    }

    var hasCurrentValidationErrorValueErrorMsgKey = utils_isType_isType.isType('object', currentValdationErrorValue) && Object.prototype.hasOwnProperty.call(currentValdationErrorValue, 'errorMsg');

    if (!hasCurrentValidationErrorValueErrorMsgKey) {
      console.error('You must to privide an "errorMsg" key when providing an object to your syncValidation');
      return 'Error message not found';
    }

    return syncValidations[errorKey].errorMsg;
  };
}

exports.validateField = validateField;
//# sourceMappingURL=validateField-179f14cb.js.map
